/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

//dispatch plan type
export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT,
  payload: data,
});

export const setComputedFields = (data) => ({
  type: ActionTypes.SET_COMPUTED_FIELDS,
  payload: data,
});
export const setAmountNDCDeatils = (data) => ({
  type: ActionTypes.SET_AMOUNT_NDC_DETAILS,
  payload: data,
});
export const setBalanceThreash = (data) => ({
  type: ActionTypes.SET_BALANCE_THREAD,
  payload: data,
});
export const setNDCCodes = (data) => ({
  type: ActionTypes.SET_NDC_CODES,
  payload: data,
});

//dispatch Maanufacturer list
export const setManufactureList = (data) => ({
  type: ActionTypes.SET_MANUFACTURERS_LIST,
  payload: data,
});

//get manufacturer list
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));

  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_DATA_LIST, values)
    .then((response) => {
      dispatch(setLoading(false));

      return dispatch(
        setManufactureList(response?.data?.rebatePercentOfSpendMfgGridVO)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setManufactureList([]));
    });
};

//dispatch rebate program

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response?.data?.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

export const getBalanceThreshold = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.DISPUTE_AMOUNT_THRESHOLD}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        setBalanceThreash(
          response?.data?.balanceDueThresholdVO?.rptBalanceDueThreshold
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setBalanceThreash([]));
    });
};

//dispatch DRAMS

export const dispatchDRAMS = (data) => ({
  type: ActionTypes.GET_DRAMS_INVOICE_START_QUARTER_VALUE,
  payload: data,
});

//get DRAMS Quarter

export const getDramsInvStartQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRAMS_INVOICE_START_QUARTER, value)
    .then((response) => {
      return dispatch(dispatchDRAMS(response?.data?.dramsInvoiceStartQuarter));
    })
    .catch((response) => {
      dispatch(dispatchDRAMS(''));
    });
};

//dispatch Earliest Qtr

export const dispatchEarliestDrugQtr = (data) => ({
  type: ActionTypes.GET_EARLIEST_QTR_DRUG_VALUE,
  payload: data,
});

//get Earliest Drag Quarter

export const getEarliestDrugQtr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EARLIEST_QTR_DRUG, value)
    .then((response) => {
      return dispatch(
        dispatchEarliestDrugQtr(
          response?.data?.earliestQtrForDrugDetailsVO?.defEarliestQtrForDrugDtls
        )
      );
    })
    .catch((response) => {
      dispatch(dispatchEarliestDrugQtr(''));
    });
};
 
// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errorMessages: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errorMessages: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

// get quarterly payment data on Search dispatch function
export const dispatchQuarterlyPaymentData = (data) => ({
  type: ActionTypes.GET_QUARTERLY_PAYMENT_DATA,
  payload: data,
});

// To get quarterly payment data on search
export const getQuarterlyPayment =
  (value, fromDisplay = false) =>
  (dispatch) => {
    dispatch(setLoading(true));

    dispatch(dispatchQuarterlyPaymentData([]));
    return axios
      .post(serviceEndPoint.GET_QUARTERLY_PAYMENT_DATA, value)
      .then((response) => {
        dispatch(setLoading(false));
        if (response?.data?.rebateQuarterlyPaymentReportVO.length === 0) {
          if (!fromDisplay) {
            dispatch(showNoDataMessage());
          }
        } else {
          dispatch(
            dispatchQuarterlyPaymentData(
              response?.data?.rebateQuarterlyPaymentReportVO
            )
          );
        }
        return response?.data?.rebateQuarterlyPaymentReportVO;
      })
      .catch(() => {
        dispatch(setLoading(false));
        dispatch(dispatchQuarterlyPaymentData([]));
      });
  };

// set the setNDCHistoryData data for display screen
export const setExportAllData = (data, key) => ({
  type: ActionTypes.SET_QUARTERLY_PAYMENT_REPORT_DATA_ALL,
  payload: data,
  key,
});
//API call to get the NDC details grid data
export const reportData = (value, i) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_QUARTERLY_PAYMENT_DATA}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(
        setExportAllData(response?.data?.rebateQuarterlyPaymentReportVO, i)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setExportAllData([], 'noData'));
    });
};
//dispatch Inv Numcheckd
export const getQuarterlyPaymentForExportAll =
  (value, mfgIdsArr) => (dispatch) => {
    for (let i = 0; i < mfgIdsArr.length; i++) {
      const values = {
        ...value,
        mfgIds: mfgIdsArr[i],
      };
      dispatch(reportData(values, i));
    }
  };

export const dispatchInvoiceNumChecked = (data) => ({
  type: ActionTypes.GET_INVOICE_NUM_CHECKED_DATA,
  payload: data,
});

//get Inv num checked

export const getInvoiceNumChecked = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_INVOICE_NUM_CHECKED, value)
    .then((response) => {
      return dispatch(
        dispatchInvoiceNumChecked(
          response?.data?.rebateQuarterlyPaymentReportVO
        )
      );
    })
    .catch((response) => {
      dispatch(dispatchInvoiceNumChecked([]));
    });
};

export const getQuarterlyPaymentForAllMfg = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QUARTERLY_PAYMENT_MFG_LIST, value)
    .then((response) => response.data.data)
    .catch((response) => []);
};

export const refreshQuarterlyPayment = () => ({
  type: ActionTypes.REFRESH_QUARTERLY_PAYMENT,
  payload: {},
});
export const refreshQuarterlyPaymentDisplay = () => ({
  type: ActionTypes.REFRESH_QUARTERLY_PAYMENT_DISPLAY,
  payload: {},
});

export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_QUARTERLY,
  payload: value,
});
